import { AccountKidProfiles } from '@/components/libs/omneo/components/AccountKidsProfiles'
import { AccountWishlists } from '@/components/libs/omneo/components/AccountWishlists'
import register from 'preact-custom-element'

const ProfilePage = () => {
  return (
    <div>
      <AccountKidProfiles />
      <AccountWishlists />
    </div>
  )
}

register(ProfilePage, 'x-profile-page')
